import { ArrowRight } from "lucide-react";

export default function Footer() {
    return (
        <footer className="px-6 pt-6 pb-14" data-testid="site-footer">
            <h2 className="font-extrabold tracking-tight leading-tight text-3xl text-ink">
                Your health, simplified and in control
            </h2>
            <p className="mt-4 text-black/55 text-[15px] leading-relaxed">
                Med Check Alarm is your trusted companion for medication management.
                We're committed to helping you stay healthy and informed.
            </p>

            <p className="mt-8 text-black/45 text-[13px] leading-relaxed" data-testid="footer-disclaimer">
                For informational purposes only — not medical advice. Valid for use in
                NZ · UK · US · AU under local privacy and consumer laws. Tap to read the full disclaimer.
            </p>

            <a
                href="#top"
                className="mt-4 inline-flex items-center gap-1.5 text-teal-dark font-semibold text-[15px] hover:text-teal transition-colors duration-200"
                data-testid="footer-legal-link"
            >
                Legal &amp; disclaimers <ArrowRight size={16} />
            </a>

            <p className="mt-10 text-black/40 text-[13px]" data-testid="footer-copyright">
                © Med Check Alarm · medcheck.org.nz
            </p>
        </footer>
    );
}
